import * as types from './types';

const INITIAL_STATE = {
  started: false,
  updateAvailable: false,
  buildDate: process.env.REACT_APP_BUILD_DATE,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.APP_START_UP:
      return {
        ...state,
        started: true,
      };
    case types.APP_UPDATE_AVAILABLE:
      return {
        ...state,
        updateAvailable: payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/state/app/reducer.js